<template>
    <div>
        <div v-if="Object.keys(currentExperimentalPlan).length>0">

            <div class="tile is-ancestor  is-vertical ">
                <div class="tile is-12 is-horizontal is-parent">
                    <div class="tile is-child box">
                        <div class="column">
                            <p class="title has-text-left">Edit Experimental Plan</p>
                        </div>

                        <div class="column">
                            <b-field class="has-text-left" label="Plan name">
                                <b-input name="experimental_plan_name" v-model="currentExperimentalPlan.name" placeholder="Experimental Plan name"></b-input>
                            </b-field>
                        </div>

                        <div class="column has-text-left">
                            <wysiwyg v-if="!generating" v-model="experimentPlanContent"></wysiwyg>
                            <loading v-else></loading>
                            <plan-content-generator
                                    ref="generator"
                                    :experimentalPlanId="currentExperimentalPlan.id"
                                    @planHtml="handlePlanContent"
                                    @loadingState="handleContentLoadingState"
                            >
                            </plan-content-generator>
                        </div>

                        <div class="column has-text-right">
                            <a class="button is-large" @click="resetContents()">
                                <span>Clear contents</span>
                            </a>
                            <span style="margin-left:20px"></span>
                            <a class="button is-large is-primary" @click="handleSubmitEditedExperimentalPlan()">
                                <span>Save</span>
                            </a>
                            <span style="margin-left:20px"></span>
                            <a class="button is-large"  @click="$router.go(-1)">
                                <span>Back</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>


            <!--  -->
        </div>
        <div v-else>
            <div class="tile is-parent">
                <div class="tile is-child">
                    <b-table
                            :loading=true>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapGetters, mapMutations } from 'vuex'
import DisplayViewModal from "../../components/modals/DisplayViewModal";
import PlanContentGenerator from "./PlanContentGenerator.vue";
import Loading from "../../valchrom/common/Loading";

export default {
    name: "EditExperimentalPlan",
    components: {DisplayViewModal,PlanContentGenerator,
        Loading},
    data: function () {
        return {
            component_url: 'experiments/plans',
            activeMethods: [],
            activeValidationPlanTemplates: [],
            currentExperimentalPlan:{},
            experimentPlanContent: null,//null when re-generating
            generatorLoading: false,
        }
    },
    computed: {
        ...mapGetters ([
            'base_url', 'auth_header', 'currentExpPlanID'
        ]),
        generating(){
            return this.experimentPlanContent == null && this.generatorLoading;
        }
    },
    mounted: function(){
        if (this.$route.params.id) {
            this.currentExperimentalPlan.id = this.$route.params.id;
        }
        else {
            console.log("EditExperimentalPlan view no router params.id", this.currentExpPlanID)
            this.currentExperimentalPlan.id =  this.currentExpPlanID
        }

        this.setBreadcrumb()
        this.getActiveValidationPlanTemplates()
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXP_PLAN_ID'
        ]),
        setBreadcrumb: function(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global currentExperimentalPlanId
        setExperimentalPlanId: function(){
            this.CHANGE_EXP_PLAN_ID(this.currentExperimentalPlan.id)
        },
        getActiveValidationPlanTemplates: function() {
            axios
                .get(`${this.base_url}experiments/templates?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeValidationPlanTemplates = response.data;
                    console.log("Active ValidationPlanTemplate in exPlanjson: ")
                    console.log(this.activeValidationPlanTemplates)
                    this.getActiveMethods()
                })
                .catch(error => {
                    console.log("Something went wrong getting the ValidationPlanTemplates :(", error);
                });
        },
        getActiveMethods: function() {
            axios
                .get(`${this.base_url}experiments/methods?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeMethods = response.data;
                    console.log("Active method in explan json: ")
                    console.log(this.activeMethods)
                    this.getExperimentalPlan()
                })
                .catch(error => {
                    console.log("Something went wrong getting the methods :(", error);
                });
        },
        getExperimentalPlan: function(){ 
            axios
                .get(
                    `${this.base_url}${this.component_url}/${this.currentExperimentalPlan.id}`,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalPlan = response.data;
                    this.experimentPlanContent = response.data.content;
                    this.currentExperimentalPlan.method = this.activeMethods.find(item => item.id == this.currentExperimentalPlan.method.id) 
                    this.currentExperimentalPlan.template = this.activeValidationPlanTemplates.find(item => item.id == this.currentExperimentalPlan.template.id)
                    this.setExperimentalPlanId()     
                    console.log("currentExperimentalPlan",this.currentExperimentalPlan)
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ExperimentalPlan in editExperimentalPlan", error);
                });
        },
        resetContents(){
            this.$dialog.confirm({
                title: 'Clear content',
                message: 'Are you sure you want to clear report content from added texts. All changes you have added will be lost!',
                focusOn: 'cancel',
                onConfirm: () => {
                    this.experimentPlanContent = null;
                    this.$refs.generator.reload();
                    this.$toast.open({
                        message: `Added content has been removed.`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                },
                onCancel: () => {
                }
            })

        },
        handleSubmitEditedExperimentalPlan: function() {
            var experimentalPlan = {
                content: this.experimentPlanContent
            };
            experimentalPlan.name = this.currentExperimentalPlan.name;
            experimentalPlan.method = this.currentExperimentalPlan.method.id;
            experimentalPlan.template = this.currentExperimentalPlan.template.id;

            axios
                .patch(
                    `${this.base_url}${this.component_url}/${this.currentExperimentalPlan.id}`,
                    experimentalPlan,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Experimental Plan Successfully Edited:", response);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan Successfully Saved`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    // this.$router.push({ name: "ExperimentalPlans", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan was not successfully Edited`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    // this.$router.push({ name: "EditExperimentalPlan", params: { id: editedExperimentalPlan.id } });
                    console.log("Experimental Plan was not successfully Edited", error.response.data);
                });
        },
        openMethodModal: function() {
            this.$modal.open({
                parent: this,
                component: DisplayViewModal,
                hasModalCard: true,
                props: {
                    currentMethod: this.activeMethods.find(method => method.id==this.currentExperimentalPlan.method.id)
                }
            })
        },
        openTemplateModal: function() {
            this.$modal.open({
                parent: this,
                component: DisplayViewModal,
                hasModalCard: true,
                props: {
                    currentValidationPlanTemplate:this.activeValidationPlanTemplates.find(template => template.id==this.currentExperimentalPlan.template.id),
                    validationParameters:this.validationParameters
                }
            })
        },
        handlePlanContent(content){
            console.log("handlePlanContent",content.substr(0,30));
            if(this.experimentPlanContent == null){
                this.experimentPlanContent = content;
            }
        },
        handleContentLoadingState(contentLoadingState){
            console.log("handleContentLoadingState",contentLoadingState);
            this.generatorLoading = contentLoadingState;
        },
    }
}
</script>
